import { render, staticRenderFns } from "./electrify.vue?vue&type=template&id=3937a445&scoped=true&"
import script from "./electrify.vue?vue&type=script&lang=js&"
export * from "./electrify.vue?vue&type=script&lang=js&"
import style0 from "./electrify.vue?vue&type=style&index=0&id=3937a445&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3937a445",
  null
  
)

export default component.exports